import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  Flex,
  ModalCloseButton,
  Spinner,
  ModalBody,
  ModalFooter,
  Button,
} from '@chakra-ui/react';
import { samplesApi } from '@texas/api/endpoints/samplesApi';
import { useApiRequest } from '@texas/api/hooks/useApiRequest';
import { useApiResource } from '@texas/api/hooks/useApiResource';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { request } from '@texas/utils/helpers/httpHelpers';
import { SamplesTable } from './SamplesTable';
import { ErrorDetails } from '../alert/ErrorDetails';
import { SharedDisclosureProps } from '../types';

interface Props extends SharedDisclosureProps {
  sampleIds: number[];
  onPerformed: () => void;
}

export function SetSamplesAsLostModal(props: Props) {
  const { t } = useTranslation();

  return (
    <Modal isOpen={props.isOpen} onClose={props.onClose} size="4xl">
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>{t('sample.markLost')}</ModalHeader>
        <ModalCloseButton />
        <Inner
          sampleIds={props.sampleIds}
          onPerform={() => {
            props.onPerformed();
            props.onClose();
          }}
        />
      </ModalContent>
    </Modal>
  );
}

function Inner({
  sampleIds,
  onPerform,
}: {
  sampleIds: number[];
  onPerform: () => void;
}) {
  const { t } = useTranslation();

  const {
    data: samples,
    refetch: refetchSamples,
    loading: samplesLoading,
    error,
  } = useApiResource(samplesApi.fromIds);

  const {
    request: mainReq,
    loading: mainReqLoading,
    error: mainReqError,
  } = useApiRequest(samplesApi.markLost);

  useEffect(() => {
    refetchSamples(sampleIds);
  }, [refetchSamples, sampleIds]);

  const req = () => request(mainReq, [sampleIds], () => onPerform());

  return (
    <>
      <ModalBody>
        <Flex flexDir="column" gap={2} w="full">
          {error && <ErrorDetails error={error} />}
          {mainReqError && <ErrorDetails error={mainReqError} />}
          {samplesLoading && <Spinner />}
          <SamplesTable samples={samples ?? []} />
        </Flex>
      </ModalBody>
      <ModalFooter>
        <Button
          isLoading={mainReqLoading}
          disabled={mainReqLoading}
          onClick={() => req()}
        >
          {t('sample.setMarkLost')}
        </Button>
      </ModalFooter>
    </>
  );
}
